var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"urge-info-time"},[_c('span',[_vm._v("距活动结束")]),_c('span',{staticClass:"urge-info-number"},[_vm._v(_vm._s(_vm.timeText)),_c('span',{staticClass:"millisecond"},[_vm._v(_vm._s(_vm.milliTimeText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }